var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-items"},[_c('img',{staticClass:"img-body",attrs:{"src":require("@/assets/image/cn/btcapp.jpg"),"alt":""}})])}]

export { render, staticRenderFns }